import React, {  } from 'react';

// Material UI
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';

import { Stack, styled, Typography } from '@mui/material';
import { NamedSpecies, Species } from '../../Types';

// Define our Supported Species here.
const SUPPORTED_SPECIES : Array<NamedSpecies> = [
  {name:"Homo sapiens (human)", species: Species.HUMAN},
  {name:"Mus musculus (house mouse)", species: Species.MOUSE},
  {name:"Rattus norvegicus (Norway rat)", species: Species.RAT},
  {name:"Macaca mulatta (Rhesus monkey)", species: Species.MM},
  {name:"Macaca fascicularis (crab-eating macaque)", species: Species.MF}
];

interface SearchCriteriaProps {
  species: Species;
  geneName: string;
  accessionNumber: string;
  customSequence: string;
}

const DarkDisabledTextField = styled(TextField)(({ theme }) => ({
  // Label
  '& .MuiInputLabel-root': {
    color: '#000',
  },
  '& .MuiInputLabel-root.Mui-disabled': {
    color: '#000',
  },

  // Input Text
  '& .MuiInputBase-input': {
    color: '#000',
    WebkitTextFillColor: '#000', // For Chrome autofill and disabled
  },
  '& .Mui-disabled .MuiInputBase-input': {
    color: '#000',
    WebkitTextFillColor: '#000',
  },

  // Outlined border
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#000',
    },
    '&.Mui-disabled fieldset': {
      borderColor: '#000',
    },
  },

  // Remove opacity on disabled inputs
  '& .MuiInputBase-root.Mui-disabled': {
    opacity: 1,
  },
}));

const SearchCriteria = ({ 
  species,
  geneName,
  accessionNumber,
  customSequence,
 }: SearchCriteriaProps) => {
  
  const renderSelectedSpecies = () => (
    <FormControl fullWidth>
      <DarkDisabledTextField
        id="species"
        select
        label="Species"
        value={species}
        disabled={true}
      >
        {SUPPORTED_SPECIES.map((item, index : number) => (
          <MenuItem value={item.species} key={index}>{item.name}</MenuItem>
        ))}
      </DarkDisabledTextField>
    </FormControl>
  );

  const renderSelectedGene = () => (
    <FormControl fullWidth>
      <DarkDisabledTextField
        id="gene"
        label="Gene Name"
        value={geneName}
        disabled={true}
      />
    </FormControl>
  );

  const renderSelectedAccessionNumber = () => (
    <FormControl fullWidth>
      <DarkDisabledTextField
        id="accession"
        label="Accession Number"
        value={accessionNumber}
        disabled={true}
      />
    </FormControl>
  );

  return (
<Box sx={{ minWidth: { xs: '100%', sm: '512px' }, height: '184px' }}>
  <Stack gap={1} direction="row" sx={{ height: '100%', alignItems: 'stretch', minHeight: 0 }}>
    <Stack gap={1} sx={{ flex: 1, minHeight: 0 }}>
      {/* your form fields */}
      <Stack flex={1}>{renderSelectedSpecies()}</Stack>
      <Stack flex={1}>{renderSelectedGene()}</Stack>
      <Stack flex={1}>{renderSelectedAccessionNumber()}</Stack>
    </Stack>
    {/* Custom Text Area */}
    {customSequence && <FormControl
      fullWidth
      sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
    >
      <InputLabel
        shrink
        htmlFor="custom-sequence-box"
        sx={{
          mb: 1,
          backgroundColor: '#fff',
          px: 1,
        }}
      >
        Custom Sequence
      </InputLabel>
      <Box
        id="custom-sequence-box"
        sx={{
          flex: 1,
          border: '1px solid #ccc',
          borderRadius: '4px',
          padding: '8px',
          fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
          fontWeight: 500,
          fontSize: '1rem',
          lineHeight: 1.3,
          letterSpacing: '.01em',
          backgroundColor: '#f9f9f9',
          overflowY: 'auto',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          maxHeight: '100%',
          maxWidth: '800px',
        }}
      >
        {customSequence}
      </Box>
    </FormControl>}
  </Stack>
</Box>

  );
};

export default SearchCriteria;